import type { GtagFn } from './register-google-analytics-provider.utils'

let cpStreamConfigured = false

interface GokollabCpStreamLogger {
  error: (message: string, context?: Record<string, unknown>) => void
}

/**
 * Configures the CP GoKollab GA4 data stream (legacy CP_GOKOLLAB_GTagID).
 * Identity remains event-scoped and is never persisted in the stream configuration.
 */
export function registerGokollabCpStream(
  gtag: GtagFn | undefined,
  cpStreamMeasurementId: string | undefined,
  sendEnabled = false,
  logger?: GokollabCpStreamLogger
): void {
  if (!sendEnabled || !gtag || !cpStreamMeasurementId?.trim() || cpStreamConfigured) {
    return
  }

  try {
    gtag('config', cpStreamMeasurementId)
    cpStreamConfigured = true
  } catch (error) {
    logger?.error('[Analytics] GoKollab CP stream config failed', { error })
  }
}

/** Resets CP stream singleton so registerGokollabCpStream can run again (logout / tests). */
export function resetGokollabCpStream(): void {
  cpStreamConfigured = false
}
